export const categories = [
  {
    id: 1,
    slug: 'jiaoben-xiezuo',
    name: '脚本写作',
    description: '从零开始学习同人漫画脚本创作，掌握角色塑造、剧情编排与对话写作的核心技巧',
    icon: 'ri-quill-pen-line',
    count: 5,
  },
  {
    id: 2,
    slug: 'fenjing-jiqiao',
    name: '分镜技巧',
    description: '深入学习漫画分镜的构图法则、镜头语言与节奏控制，让画面讲述更生动的故事',
    icon: 'ri-layout-grid-line',
    count: 5,
  },
  {
    id: 3,
    slug: 'huizhi-jifa',
    name: '绘制技法',
    description: '涵盖线稿、上色、背景绘制等实用技法，帮助提升同人漫画的视觉表现力',
    icon: 'ri-brush-line',
    count: 5,
  },
  {
    id: 4,
    slug: 'fabu-pingtai',
    name: '发布平台',
    description: '汇总国内外主流同人漫画投稿与发布平台，对比特点与适用场景',
    icon: 'ri-earth-line',
    count: 5,
  },
  {
    id: 5,
    slug: 'banquan-xuzhi',
    name: '版权须知',
    description: '了解同人创作涉及的法律边界、合理使用原则与版权保护策略',
    icon: 'ri-shield-check-line',
    count: 5,
  },
];